<template>
  <div>
    <!-- 幸运盲盒 -->
    <div class="blindBox">
      <div class="perTit">
        <img :src="require('@/assets/imgs/shop/perTit1.png')" alt="">
        <span>幸运盲盒</span>
      </div>
      <div class="blindBoxCon">
        <div class="conL">
          <img class="mb10" :src="require('@/assets/imgs/shop/blingBoxBg2.png')" alt="" width="100%">
          <img class="goBlingBoxBtn" :src="require('@/assets/imgs/shop/blingBoxBtn.png')" alt="" @click="goBlingBox">
        </div>
        <!-- <div class="conR">
          <BlindBoxRecord></BlindBoxRecord>
        </div> -->
      </div>
    </div>

    <!-- 热卖区 -->
    <div class="hotArea" id="hotArea">
      <div class="perTit">
        <img :src="require('@/assets/imgs/shop/perTit2.png')" alt="">
        <span>热卖区</span>
      </div>
      <div class="hotAreaCon">
        <div class="hotAreaConL">
          <div v-if="hotGoods" class="item" v-for="(item, index) in hotGoods">
            <div class="picWrap">
              <div style="height: 33px">
                <div v-if="item.isLimitTime" class="limitTimeWrap">
                  <span class="limitTime">{{ endTime(item.endTime) }}停售</span>
                </div>
              </div>
              <el-tooltip effect="dark" :content="item.goodsDesc">
                <img :src="item.goodsIcon" alt="" style="max-width: 100px;">
              </el-tooltip>
              <div class="limitWrap" v-if="item.goodsType == 1 && item.buyMaxCount > 0">
                <span class="limit">限购{{ item.buyMaxCount }}件</span>
              </div>
            </div>
            <div class="name">{{ item.goodsName }}</div>
            <div class="moneyWrap">
              <span class="money">
                <template v-if="item.currencyName == '金龙元宝'">
                  <Tip :titInd="0" style="width:20px;vertical-align: bottom"></Tip>
                </template>
                <template v-else-if="item.currencyName == '银龙元宝'">
                  <Tip :titInd="1" style="width:20px;vertical-align: bottom"></Tip>
                </template>
                <template v-else-if="item.currencyName == '积分'">
                  <Tip :titInd="2" style="width:20px;vertical-align: bottom"></Tip>
                </template>
                <template v-else-if="item.currencyName == '精品券'">
                  <Tip :titInd="3" style="width:20px;vertical-align: bottom"></Tip>
                </template>
                {{ item.goodsPrice }}
              </span>
            </div>
            <template v-if="item.isTodayGet == 1">
              <div class="buyBtn buyBtn1">购买</div>
            </template>
            <template v-else>
              <div v-if="item.vipLevel == 0" class="buyBtn" @click="hotBuy(item)">购买</div>
              <div v-else-if="!(item.vipLevel <= VipGrade)" class="buyBtn" @click="NoBuy(item)" style="color: #fccf46;">
                仅限vip{{ item.vipLevel }}以上购买</div>
              <div v-else class="buyBtn" @click="hotBuy(item)">购买</div>
            </template>
          </div>
          <!-- 分页器 -->
          <div style="width: 100%;float: left;">
            <el-pagination style="text-align: center;" @current-change='HotGoodPage' :page-size="15" background
              layout="prev, pager, next" :total="hotGoodscounts">
            </el-pagination>
          </div>
          <!-- <div v-if="hotGoods" class="item" v-for="(item,index) in hotGoods.list">
            <el-tooltip effect="dark" :content="item.goodsDesc">
              <div class="picWrap"><img :src="item.goodsIcon" alt=""></div>
            </el-tooltip>
            <div class="name">{{item.goodsName}}</div>
            <div class="moneyWrap">
              <span class="money">
                <template v-if="item.currencyName == '白金币'"><Tip :titInd="0" style="width:20px;vertical-align: bottom"></Tip></template>
                <template v-else-if="item.currencyName == '绑定白金币'"><Tip :titInd="1" style="width:20px;vertical-align: bottom"></Tip></template>
                <template v-else-if="item.currencyName == '积分'"><Tip :titInd="2" style="width:20px;vertical-align: bottom"></Tip></template>
                <template v-else-if="item.currencyName == '精品券'"><Tip :titInd="3" style="width:20px;vertical-align: bottom"></Tip></template>
                {{item.goodsPrice}}
              </span>
            </div>
            <div class="buyBtn" @click="hotBuy(item)">购买</div>
          </div>-->
        </div>

      </div>
    </div>
    <div class="hotAreaConR" :style="{ right: myRight, left: myLeft }">
      <div class="hotAreaConRMain">
        <!-- <img class="closed" @click="hotAreaConRShow = false" :src="require('@/assets/imgs/shop/close.png')" alt=""> -->
        <HotSell :hotSellData="bestGoods" @bestBuy="bestBuy"></HotSell>
      </div>
    </div>

    <!-- 超值购 -->
    <div class="superValue" id="superValue">
      <div class="perTit">
        <img :src="require('@/assets/imgs/shop/perTit3.png')" alt="">
        <span>超值购</span>
      </div>
      <div class="superValueCon">
        <div class="superValueConT">
          <div class="item" v-for="(item, index) in superGoods" v-if="item.isPeriod == 1">
            <span class="residue" v-if="item.expDate > 0" :style="{ backgroundImage: 'url(' + supperBuyBg + ')' }">
              <b>剩余{{ item.expDate }}天</b></span>
            <el-tooltip effect="dark" :content="item.goodsDesc"><img :src="item.goodsIcon" alt="">
            </el-tooltip>

            <div v-if="!(item.vipLevel <= VipGrade)" class="txt" style="color: #fccf46;">
              <span @click="NoBuy(item)"> 仅限vip{{ item.vipLevel }}以上购买</span>
            </div>
            <div v-else>
              <div class="txt" v-if="item.expDate == null || item.expDate == 0">
                <span @click="hotBuy(item)">{{ item.goodsPrice }}{{ item.currencyName }}</span>
              </div>
              <div class="txt" v-else>
                <template v-if="item.isTodayGet == 1"><span class="over">今日已领取</span></template>
                <template v-else><span @click="receive(item)">领取</span></template>
              </div>
            </div>

          </div>
        </div>
        <div class="superValueConB">
          <div class="item" v-for="(item, index) in superGoods" v-if="item.isPeriod == 0">
            <div class="picWrap">
              <div style="height: 33px">
                <div v-if="item.isLimitTime" class="limitTimeWrap">
                  <span class="limitTime">{{endTime(item.endTime)}}停售</span>
                </div>
              </div>
              <el-tooltip effect="dark" :content="item.goodsDesc">
                <img :src="item.goodsIcon" alt="">
              </el-tooltip>
              <div class="limitWrap" v-if="item.goodsType == 1 && item.buyMaxCount > 0">
                <span class="limit">限购{{ item.buyMaxCount }}件</span>
              </div>
            </div>
            <div class="name">{{ item.goodsName }}</div>
            <div class="moneyWrap">
              <!-- <span class="money"> -->
                <template v-if="item.currencyName == '金龙元宝'">
                  <Tip :titInd="0" style="width:20px;vertical-align: bottom"></Tip>
                </template>
                <template v-else-if="item.currencyName == '银龙元宝'">
                  <Tip :titInd="1" style="width:20px;vertical-align: bottom"></Tip>
                </template>
                <template v-else-if="item.currencyName == '积分'">
                  <Tip :titInd="2" style="width:20px;vertical-align: bottom"></Tip>
                </template>
                <template v-else-if="item.currencyName == '精品券'">
                  <Tip :titInd="3" style="width:20px;vertical-align: bottom"></Tip>
                </template>
                {{ item.goodsPrice }}
              <!-- </span> -->
            </div>
            <template v-if="item.isTodayGet == 1">
              <div class="buyBtn buyBtn1">购买</div>
            </template>
            <template v-else>
              <div v-if="!(item.vipLevel <= VipGrade)" class="buyBtn" style="color: #fccf46;">
                <span @click="NoBuy(item)"> 仅限vip{{ item.vipLevel }}以上购买</span>
              </div>
              <div v-else class="buyBtn" @click="hotBuy(item)">购买</div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <pubMask v-if="pubMaskIsShow" :showWhich="showWhich" :goodTitle="goodTitle" :goodsPrice="goodsPrice"
      :goodsInfo="goodsInfo" :maxCount="maxCount" @closeMask="closeMask"></pubMask>
  </div>
</template>

<script>
import eventBus from '@/common/bus.js'
import HotSell from '@/components/HotSell/HotSell'
import pubMask from '@/components/pubMask'
import BlindBoxRecord from '@/components/BlindBoxRecord'
import Tip from "@/components/Tip";

import axios from "axios";
import Cookies from "js-cookie";

import { indexGoodsListApi, getGoodsExchangeApi, getGoodsByMaxCountApi } from "@/api/home/index.js";
export default {
  name: "personWarehouse",
  components: {
    HotSell,          // 爆款热卖
    pubMask,          // 公共弹窗
    BlindBoxRecord,
    Tip
  },
  props: {
    type: '',
  },
  data() {
    return {
      hotGoods: {},        // 热卖
      hotGoodscounts: 0,        // 热卖数量
      bestGoods: {},       // 爆款
      superGoods: {},      // 超值购
      pubMaskIsShow: false,  // 是否显示弹窗
      showWhich: 7,        // 当前显示弹窗是购买弹窗
      goodTitle: '',       // 商品名称
      goodsPrice: 0,       // 商品价格
      maxCount: 1,         // 最大购买数量
      curTimestamp: 0,     //  当前时间
      supperBuyBg: require('@/assets/imgs/shop/supperBuyBg.png'),
      //isFixed:false,
      //isGtTop:false,
       myRight: 'auto',
      myLeft: 'auto',
      VipGrade: '', //vip等级
      userInfo: ''
    }
  },
  created() {
    this.indexGoodsList()
    eventBus.$on('resetIndexGoodsList', this.indexGoodsList)
    window.addEventListener('resize', this.winResize)
    //window.addEventListener("scroll", this.scrollT)
  },
  mounted() {
    this.winResize()
    let userInfo = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : ''
    if (userInfo) {
      this.VipGrade = Number(userInfo ? userInfo.vipInfo.viplevel.match(/\d+/)[0] : 0)

    }

  },
  methods: {
 winResize() {
      let winW = document.documentElement.clientWidth
      if (winW < 1600) {
        this.myRight = 20 + 'px'
        this.myLeft = 'auto'
      } else {
        this.myRight = 'auto'
        this.myLeft = (winW - 1000) / 2 + 1020 + 'px'
      }
    },

    bestBuy(data) {            // 爆款热卖
      this.hotBuy(data)
    },
    async HotGoodPage(e) {
      await indexGoodsListApi({
        pageNum: e,
        pageSize: 15,
      })
        .then(({ data }) => {
          if (data.state == 200) {
            this.hotGoods = data.data.hotGoods.list // 热卖
            this.hotGoodscounts = data.data.hotGoods.counts
          } else {
            this.$message.error(res.data.message)
          }

        })
    },
    async indexGoodsList() {     //  cateId: 1:热卖区 2：爆款，3：超值
      await indexGoodsListApi({
        pageNum: 1,
        pageSize: 15,
      })
        .then(({ data }) => {
          if (data.state == 200) {
            this.hotGoods = data.data.hotGoods.list // 热卖
            this.hotGoodscounts = data.data.hotGoods.counts
            this.bestGoods = data.data.bestGoods.list    // 爆款
            this.superGoods = data.data.superGoods.list     // 超值购
          } else {
            this.$message.error(res.data.message)
          }

        })
      setTimeout(() => {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : ''

        if (this.userInfo) {
          this.VipGrade = Number(this.userInfo ? this.userInfo.vipInfo.viplevel.match(/\d+/)[0] : 0)
        }
      }, 100)
    },


    NoBuy(item) {
      this.$message.info(`仅限vip${item.vipLevel}以上购买`)
    },
    async hotBuy(item) {               // 热卖购买弹窗
      if (Cookies.get('cwsl_token')) {
        if (item.buyMaxCount == 0 || item.buyMaxCount == null) {
          // axios({
          //   method: 'post',
          //   url: '/shop/order/getGoodsByMaxCount',
          //   headers: {
          //     token: Cookies.get('cwsl_token'),
          //   },
          //   data: {

          //   }
          // })
          await getGoodsByMaxCountApi({
            goodsId: item.goodsId,
            platForm: 'web',
            userId: Cookies.get('cwsl_userId')
          }).then(res => {
            if (res.data.state == 200) {
              this.maxCount = res.data.data.maxCount
              this.goodsInfo = item
              this.goodTitle = item.goodsName
              this.goodsPrice = item.goodsPrice
              this.showWhich = 7
              this.pubMaskIsShow = true
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          this.maxCount = item.buyMaxCount
          this.goodsInfo = item
          this.goodTitle = item.goodsName
          this.goodsPrice = item.goodsPrice
          this.showWhich = 7
          this.pubMaskIsShow = true
        }
      } else {
        this.$message.error('请先登录')
      }
    },
    async receive(item) {          // 超值购 - 领取
      if (Cookies.get('cwsl_token')) {
        await getGoodsExchangeApi({
          exchangeId: item.exchangeId,
          goodsId: item.goodsId,
          periodType: item.periodType,
          platForm: 'web',
          userId: Cookies.get('cwsl_userId')
        })
          .then(res => {
            if (res.data.state == 200) {
              this.$message.success(res.data.message)
              eventBus.$emit('resetIndexGoodsList')
              eventBus.$emit('resetUserInfo')
            } else {
              this.$message.error(res.data.message)
            }
          })
      } else {
        this.$message.error('请先登录')
      }
    },
    closeMask() {                // 关闭弹窗
      this.pubMaskIsShow = false
    },
    maoDianFn(data) {            // 锚点定位
      let domScrollT = ''
      if (data == 'hot') {
        domScrollT = document.getElementById('hotArea').offsetTop;
      } else if (data == 'supper') {
        domScrollT = document.getElementById('superValue').offsetTop;
      }
      document.scrollingElement.scrollTop = domScrollT;
    },
    goBlingBox() {       // 去盲盒页面
      if (Cookies.get('cwsl_token')) {
        this.$router.push({ path: '/shop/blindBox' })
        document.scrollingElement.scrollTop = 0
      } else {
        this.$message.error('请先登录！')
      }
    },

    endTime(diffTime) {
      let date = new Date(parseInt(diffTime) * 1000);
      let Moth = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      let Day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
      let Hours = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
      return Moth + '月' + Day + '日' + Hours + '时'
    }
  },

  watch: {
    type: {
      handler(newv) {
        let _this = this
        setTimeout(() => {
          _this.maoDianFn(newv)
        }, 100)
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  }
}
</script>

<style scoped lang="less">
.perTit {
  padding: 10px;
  border-bottom: 1px solid #333333;

  img {
    margin-right: 5px;
    height: 24px;
    vertical-align: middle;
  }

  span {
    font-size: 20px;
    font-weight: 700;
    font-family: 'YOUSHEhaoshenti';
    vertical-align: middle;
  }
}

.blindBoxCon {
  padding: 20px 0 34px;
  display: flex;
  justify-content: space-between;

  .conL {
    // width: 77%;
    width: 100%;
    text-align: center;

    .goBlingBoxBtn {
      cursor: pointer;
    }
  }

  .conR {
    width: 20%;

    // padding-top:20px;
    .prop {
      width: 130px;
      border: 2px solid #D22190;
      border-radius: 20px;
      background: #fff;

      .tit {
        margin-top: -20px;
        margin-left: -2px;
        width: 90px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
        color: #fff;
        background: #5472F6;
        border-radius: 18px 18px 18px 0;
      }

      .propMain {
        height: 250px;
        text-align: center;

        .pic {
          display: inline-block;
          margin: 5px;
          width: 48px;
          height: 40px;
          line-height: 40px;
          border: 1px solid #000;
          box-sizing: border-box;

          img {
            width: 48px;
            height: 40px;
          }
        }
      }
    }

    .record {
      text-align: center;

      span {
        margin-top: 12px;
        display: inline-block;
        width: 118px;
        height: 37px;
        line-height: 37px;
        text-align: center;
        border-radius: 18px;
        font-size: 20px;
        color: #fff;
        background: #5472F6;
        cursor: pointer;
      }
    }
  }
}

.hotAreaCon {
  padding: 20px 0 34px;
  overflow: hidden;
  display: flex;

  .hotAreaConL {
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;

    .item {
      margin-bottom: 15px;
      float: left;
      width: 136px;
      margin-right: 9px;

      .picWrap {
        text-align: center;
        width: 128px;
        height: 120px;
        border: 4px solid #5472F6;
        overflow: hidden;

        img {
          height: 64px;
        }

        .limitTimeWrap {
          padding-top: 8px;
          text-align: center;
          background: url("../../../assets/imgs/shop/superValueLimit.png") no-repeat top center;

          .limitTime {
            display: inline-block;
            width: 110px;
            height: 25px;
            color: #fff;
            font-size: 12px;
          }
        }

        .limitWrap {
          .limit {
            margin-top: 2px;
            display: inline-block;
            width: 100px;
            height: 20px;
            line-height: 20px;
            color: #fff;
            font-size: 12px;
            background: #5472F6;
          }
        }

        /*.limit{
            position: absolute;
            left: -27px;
            top: 6px;
            z-index: 2;
            font-size: 12px;
            width: 100px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            background: #FF586C;
            transform: rotate(-35deg);
          }*/
      }

      .name {
        padding: 10px;
        height: 34px;
        font-size: 14px;
        text-align: center;
        color: #333;
        font-weight: 700;
        white-space: nowrap;
        box-sizing: border-box;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .moneyWrap {
        margin-bottom: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 2px;
        overflow: hidden;

        .money {
          width: 100%;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          background: #555555;
        }

        /*.moneyUnit{
            width:56px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            background: #555555;
          }*/
      }

      .buyBtn {
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        background: #5472F6;
      }

      .buyBtn1 {
        color: #fff;
        cursor: default;
        background: #555555;
      }

      // &:nth-child(5n) {
      //   margin-right: 0;
      // }
    }

    /*.item{
        margin-bottom: 15px;
        float: left;
        width: 136px;
        margin-right: 10px;
        .picWrap{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 128px;
          height: 120px;
          border:4px solid #FF586C;
          img{
            width: 92px;
          }
        }
        .name{
          padding:10px;
          height: 34px;
          font-size: 14px;
          text-align: center;
          color: #333;
          font-weight: 700;
          white-space: nowrap;
          box-sizing: border-box;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .moneyWrap{
          margin-bottom: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 2px;
          overflow: hidden;
          .money{
            width: 100%;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            background: #555555;
          }
        }
        .buyBtn{
          height: 24px;
          line-height: 24px;
          text-align: center;
          color: #fff;
          background: #FF586C;
          cursor: pointer;
        }
      }*/
  }
}

.hotAreaConR {
  position: fixed;
  top: 140px;
  right: -300px;

  .hotAreaConRMain {
    position: relative;
    z-index: 0;
    background: #FFF5F5;
    box-shadow: 0 0 20px #dddddd;


    .closed {
      position: absolute;
      right: -18px;
      top: -18px;
      width: 50px;
      cursor: pointer;
    }
  }
}

.superValueCon {
  // margin: 20px 0;
  // padding: 20px 0;

  .superValueConT {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    padding: 0 5px;

    .item {
      position: relative;
      z-index: 0;
      margin-right: 10px;
      width: 25%;
      height: 169px;

      .residue {
        position: absolute;
        right: 7px;
        top: 3px;
        z-index: 1;
        display: inline-block;
        padding: 0;
        width: 74px;
        height: 42px;
        background-repeat: no-repeat;

        b {
          position: absolute;
          right: 7px;
          top: 10px;
          z-index: 1;
          display: inline-block;
          transform: rotate(25deg);
          font-size: 12px;
          color: #fff;
        }
      }

      &:last-child {
        margin-right: 0;
      }

      img {
        width: 100%;
      }

      .txt {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 1;
        width: 100%;
        text-align: center;

        .over {
          color: #ffffff;
          background: linear-gradient(#aeaeae, #555555);
          cursor: default;
        }
      }

      span {
        padding: 5px 10px;
        color: #7b3a03;
        font-size: 17px;
        font-weight: 700;
        background: linear-gradient(#fef5a3, #fed444);
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }

  .superValueConB {
    box-sizing: border-box;
    overflow: hidden;
    // padding: 20px 0;

    .item {
      margin-bottom: 15px;
      float: left;
      width: 136px;
      margin-right: 7px;

      .picWrap {
        text-align: center;
        width: 128px;
        height: 120px;
        border: 4px solid #5472F6;
        overflow: hidden;

        img {
          height: 64px;
        }

        .limitTimeWrap {
          padding-top: 8px;
          text-align: center;
          background: url("../../../assets/imgs/shop/superValueLimit.png") no-repeat top center;

          .limitTime {
            display: inline-block;
            width: 110px;
            height: 25px;
            color: #fff;
            font-size: 12px;
          }
        }

        .limitWrap {
          .limit {
            margin-top: 2px;
            display: inline-block;
            width: 100px;
            height: 20px;
            line-height: 20px;
            color: #fff;
            font-size: 12px;
            background: #5472F6;
          }
        }

        /*.limit{
            position: absolute;
            left: -27px;
            top: 6px;
            z-index: 2;
            font-size: 12px;
            width: 100px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            background: #FF586C;
            transform: rotate(-35deg);
          }*/
      }

      .name {
        padding: 10px;
        height: 34px;
        font-size: 14px;
        text-align: center;
        color: #333;
        font-weight: 700;
        white-space: nowrap;
        box-sizing: border-box;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .moneyWrap {
        margin-bottom: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        overflow: hidden;

        // .money {
        //   width: 100%;
          height: 20px;
        //   line-height: 20px;
        //   text-align: center;
          color: #fff;
          background: #555555;
        // }

        /*.moneyUnit{
            width:56px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            background: #555555;
          }*/
      }

      .buyBtn {
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        background: #5472F6;
      }

      .buyBtn1 {
        color: #fff;
        cursor: default;
        background: #555555;
      }

      &:nth-child(5n) {
        margin-right: 0;
      }
    }
  }
}
</style>
